import React from 'react';

function Date({ day, month, circle }) {
  return (
    <div className={`date-box ${circle ? '-circle' : ''}`}>
      <div className='-date'>
        <h3 className='-day'>{day}</h3>
        <span className='-month'>{month}</span>
      </div>
    </div>
  );
}

export default Date;
